import ProgressBar from "./ProgressBar"
import RoadmapCard from "./RoadmapCard"

function Roadmap(){
    return(
    <div 
    className="flex justify-center h-full w-full text-white md:gap-x-12 relative">
        {/*COLUMN 1 */}
        <div className="flex flex-col justify-around items-center  w-[35vh]">
        <RoadmapCard step="1" title="Genesis" text="Launch of Pepe Coin Website Development of Pepe Coin Smart Contract
        Establishment of Pepe Coin Social Media Channels."/>
        <RoadmapCard step="3" title="Visibility" text="Initiate Pepe Coin Marketing Campaign
        Submit Pepe Coin Application to CoinMarketCap Submit Pepe Coin Application to CoinGecko."/>
        <RoadmapCard step="5" title="Interstellar Journey" text="Achieve First Listings on Centralized Exchanges for Pepe Coin 
        Sustain Marketing Efforts for Pepe Coin Implement Community Incentives for Pepe Coin Holders."/>
        </div>

        <ProgressBar/>
        
        {/*COLUMN 3 */}
        <div className="flex flex-col justify-evenly items-center w-[35vh]">
        <RoadmapCard step="2" title="Growth" text="Secure First Listings on Decentralized Exchanges for Pepe Coin Update Pepe Coin Data on DEXTools Enhance Pepe Coin Visibility on Birdeye."/>
        <RoadmapCard step="4" title="Expansion" text="Conduct Pepe Coin Smart Contract Audit Commence Pepe Coin Presale
        Community Engagement and Expansion."/>
        </div>
    </div>
    )
}

export default Roadmap